module.exports = __webpack_public_path__ + "WhatsApp_Logo_2.png?2e02b0968ef3e7c4496a4bd5a78e6d2b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WhatsApp_Logo_2.png
// module id = 369
// module chunks = 22